export default __webpack_public_path__ + "static/media/icon-notification.7b8147c2.svg";